<template>
  <router-view></router-view>
</template>

<script setup>

</script>
<style lang="scss">
#app {
  font-family: PingFangSC, PingFang SC;
  ;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: rgba(58, 98, 215, 0.1);
}

</style>